import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ErrorComponent } from './components/_shared/error/error.component';
import { MainLayoutComponent } from './components/_shared/main-layout/main-layout.component';
import { ActivationComponent } from './components/account/activation/activation.component';
import { ChangePasswordComponent } from './components/account/change-password/change-password.component';
import { ForgottenLoginComponent } from './components/account/forgotten-login/forgotten-login.component';
import { LoginComponent } from './components/account/login/login.component';
import { RegisterCompleteComponent } from './components/account/register-complete/register-complete.component';
import { RegisterComponent } from './components/account/register/register.component';
import { RequestPaymentComponent } from './components/account/request-payment/request-payment.component';
import { ResendActivationComponent } from './components/account/resend-activation/resend-activation.component';
import { ResetPasswordComponent } from './components/account/reset-password/reset-password.component';
import { RightOfAccessComponent } from './components/account/right-of-access/right-of-access.component';
import { RightToErasureComponent } from './components/account/right-to-erasure/right-to-erasure.component';
import { AccountSettingsComponent } from './components/account/settings/account-settings.component';
import { CourseAreaDetailComponent } from './components/course-areas/detail/course-area-detail/course-area-detail.component';
import { CourseAreaApplyFiltersComponent } from './components/course-areas/filters/course-area-apply-filters/course-area-apply-filters.component';
import { CourseAreaBudgetFilterComponent } from './components/course-areas/filters/course-area-budget-filter/course-area-budget-filter.component';
import { CourseAreaCoursesFilterComponent } from './components/course-areas/filters/course-area-courses-filter/course-area-courses-filter.component';
import { CourseAreaLanguagesFilterComponent } from './components/course-areas/filters/course-area-languages-filter/course-area-languages-filter.component';
import { CourseAreaLocationFilterComponent } from './components/course-areas/filters/course-area-location-filter/course-area-location-filter.component';
import { CourseAreaPointsFilterComponent } from './components/course-areas/filters/course-area-points-filter/course-area-points-filter.component';
import { CourseAreaListComponent } from './components/course-areas/list/course-area-list/course-area-list.component';
import { ExportComponent } from './components/finalise/export/export.component';
import { FinaliseListComponent } from './components/finalise/list/finalise-list.component';
import { HelpComponent } from './components/help/help/help.component';
import { PrivacyPolicyComponent } from './components/legal/privacy-policy/privacy-policy.component';
import { PrivacyPolicyUpdateComponent } from '@app/components/legal/privacy-policy-update/privacy-policy-update.component';
import { QuestionnaireCompleteComponent } from './components/questionnaire/questionnaire-complete/questionnaire-complete.component';
import { QuestionnaireComponent } from './components/questionnaire/questionnaire/questionnaire.component';
import { ReviewQuestionsComponent } from './components/questionnaire/review-questions/review-questions.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { AuthGuardService } from './services/guards/auth-guard.service';
import { CanDeactivateGuard } from './services/guards/can-deactivate-guard.service';
import { CanRegisterService } from './services/guards/can-register.service';

const routes: Routes = [
  { path: ErrorComponent.route, component: ErrorComponent },
  { path: RegisterCompleteComponent.route, component: RegisterCompleteComponent },
  { path: ActivationComponent.route, component: ActivationComponent },
  { path: ForgottenLoginComponent.route, component: ForgottenLoginComponent },
  { path: ResendActivationComponent.route, component: ResendActivationComponent },
  { path: LoginComponent.route, component: LoginComponent, canActivate: [AuthGuardService] },
  { path: ResetPasswordComponent.route, component: ResetPasswordComponent },
  { path: ChangePasswordComponent.route, component: ChangePasswordComponent },
  /*{
    path: RegisterComponent.route,
    component: RegisterComponent,
    canActivate: [CanRegisterService, AuthGuardService]
  },*/
  {
    path: ReviewQuestionsComponent.route,
    component: ReviewQuestionsComponent,
    canActivate: [AuthGuardService],
    pathMatch: 'full'
  },
  { path: WelcomeComponent.route, component: WelcomeComponent, canActivate: [AuthGuardService] },
  {
    path: RightOfAccessComponent.route,
    component: RightOfAccessComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: RightToErasureComponent.route,
    component: RightToErasureComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: AccountSettingsComponent.route,
    component: AccountSettingsComponent,
    canActivate: [AuthGuardService]
  },

  { path: PrivacyPolicyComponent.route, component: PrivacyPolicyComponent },
  { path: PrivacyPolicyUpdateComponent.route, component: PrivacyPolicyUpdateComponent },
  { path: HelpComponent.route, component: HelpComponent },
  {
    path: MainLayoutComponent.route,
    component: MainLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      { path: QuestionnaireComponent.route, component: QuestionnaireComponent },
      { path: QuestionnaireCompleteComponent.route, component: QuestionnaireCompleteComponent },
      {
        path: CourseAreaListComponent.route,
        component: CourseAreaListComponent,
        canDeactivate: [CanDeactivateGuard]
      },
      { path: CourseAreaDetailComponent.route, component: CourseAreaDetailComponent },
      { path: CourseAreaApplyFiltersComponent.route, component: CourseAreaApplyFiltersComponent },
      { path: CourseAreaBudgetFilterComponent.route, component: CourseAreaBudgetFilterComponent },
      {
        path: CourseAreaLanguagesFilterComponent.route,
        component: CourseAreaLanguagesFilterComponent
      },
      { path: CourseAreaPointsFilterComponent.route, component: CourseAreaPointsFilterComponent },
      {
        path: CourseAreaLocationFilterComponent.route,
        component: CourseAreaLocationFilterComponent
      },
      { path: CourseAreaCoursesFilterComponent.route, component: CourseAreaCoursesFilterComponent },
      { path: RequestPaymentComponent.route, component: RequestPaymentComponent },
      { path: FinaliseListComponent.route, component: FinaliseListComponent },
      { path: ExportComponent.route, component: ExportComponent },
      {
        path: 'courses',
        loadChildren: 'app/courses/courses.module#CoursesModule'
      },
      {
        path: 'personal-statement-questions',
        loadChildren:
          'app/personal-statement-questions/personal-statement.module#PersonalStatementQuestionsModule'
      },
      { path: '**', redirectTo: QuestionnaireComponent.route, pathMatch: 'full' }
    ]
  },
  { path: '**', redirectTo: LoginComponent.route, pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts